module.exports = __webpack_public_path__ + "img/NIST-mmg-words.9c7d6d34.png";